// extracted by mini-css-extract-plugin
export default {"main":"styles_main__+U9uQ","left":"styles_left__DWJ1n","right":"styles_right__2VJ0M","disabled":"styles_disabled__GZmFk","dots":"styles_dots__epY9o","active":"styles_active__asW-x"};